const domainCodes = (() => {
  try { return JSON.parse(process.env.REACT_APP_DOMAIN_CODES || '{}'); }
  catch { return {}; }
})();

export const getSchoolHomeHash = () => domainCodes[window.location.host] || null;
export const isSchoolHomeDomain = () => !!getSchoolHomeHash();
export const hasSchoolHomeByHash = (hash) => !!hash && Object.values(domainCodes).includes(hash);
